module.exports = __webpack_public_path__ + "static/media/foto3.b044f4cd.jpg";